import React from 'react';
import { Button } from './ui/button';
import { useInteractionMode } from '../contexts/InteractionModeContext';
import { MousePointer, Hand } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const InteractionModeToggle: React.FC = () => {
  const { mode, setMode } = useInteractionMode();

  const toggleMode = () => {
    setMode(mode === 'drag-and-drop' ? 'tap-to-location' : 'drag-and-drop');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={toggleMode}
            size="icon"
            variant="ghost"
            className="rounded-full"
            aria-label="Toggle interaction mode"
          >
            {mode === 'drag-and-drop' ? (
              <MousePointer className="h-[1.2rem] w-[1.2rem]" />
            ) : (
              <Hand className="h-[1.2rem] w-[1.2rem]" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {mode === 'drag-and-drop'
              ? 'Currently: Drag & Drop (click to switch to Tap Mode)'
              : 'Currently: Tap Mode (click to switch to Drag & Drop)'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InteractionModeToggle;
